<script setup lang="ts">
import usePoolStore from '~/store/pool'
import { formatDistance } from '~/utils/format'
import CategoriesIcons from './CategoriesIcons.vue'

const { locale, t } = useI18n()

const getLocationType = (item: any): string =>
    item?.pool?.locationTypeSlug || 'unknown'

const distanceUnit = (distance: number): string => {
    if (distance < 1000) {
        return t('meters')
    }

    return 'km'
}

const getItemPoolProperty = (item: any, property: string): string =>
    item.pool[property] || ''

const getItemDistance = (item: any): number => item.distance || 0

const onClickOnAPool = (item: any) => {
    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            {
                action: 'openUrl',
                url: `${item.pool.slug}.html`,
                target: '_blank'
            },
            document.referrer
        )
    } else {
        const newWnd = window.open(
            getChargemapUrl(`/${item.pool.slug}.html`, locale.value),
            '_top'
        )

        if (newWnd) {
            newWnd.opener = null
        }
    }
}

onMounted(() => usePoolStore().fetchNearStations())
</script>

<template>
    <div>
        <Loader v-if="usePoolStore().mappyLoader" class="min-h-140" />
        <div v-else class="text-sm">
            <div
                v-for="(item, index) of usePoolStore().nearStations"
                :key="getItemPoolProperty(item, 'name')"
            >
                <div
                    v-if="getItemDistance(item) !== 0"
                    class="flex flex-col w-full min-h-70 relative my-3"
                >
                    <div
                        class="flex justify-between w-full mb-3 cursor-pointer"
                        @click="onClickOnAPool(item)"
                    >
                        <div
                            class="flex items-center justify-center p-2.5 min-w-70 min-h-70 text-3xl rounded-lg border-1 overflow-hidden w-auto h-full border-gray-l-200 mr-3"
                        >
                            <CategoriesIcons
                                v-if="getLocationType(item)"
                                class="h-8"
                                :category="getLocationType(item)"
                            />
                        </div>
                        <div class="flex justify-between w-full items-center">
                            <div class="text-black text-xs">
                                <h3
                                    class="text-gray-l-800 text-0.5sm text-left"
                                >
                                    {{ getItemPoolProperty(item, 'name') }}
                                </h3>
                                <p>
                                    {{ getItemPoolProperty(item, 'number') }}
                                    {{
                                        getItemPoolProperty(item, 'street_name')
                                    }}
                                </p>
                                <p>
                                    {{
                                        getItemPoolProperty(item, 'postal_code')
                                    }}
                                    {{ getItemPoolProperty(item, 'city') }}
                                </p>
                            </div>
                            <div class="text-center w-max ml-2">
                                <p class="text-3xl text-black">
                                    {{ formatDistance(getItemDistance(item)) }}
                                </p>
                                <p class="text-sm text-gray-l-400">
                                    {{ distanceUnit(getItemDistance(item)) }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <span
                        v-if="index !== usePoolStore().nearStations.length - 1"
                        class="w-full border-b-1 border-gray-l-200"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
